import React from 'react';
import PillarPageLayout from '../components/PillarPageLayout';

const SharePage: React.FC = () => {
  const DeviceStack = () => (
    <div className="flex flex-col gap-2 items-center">
      {['Dad\'s phone', 'Mum\'s tablet', 'Kid\'s iPad', 'Laptop'].map((d) => (
        <div key={d} className="px-3 py-1.5 rounded-md text-xs font-medium bg-white border border-slate-300 text-slate-600">
          {d}
        </div>
      ))}
    </div>
  );

  const diagram = (
    <>
      <p className="font-semibold text-slate-700 mb-5 text-center text-sm">Without Megadish</p>
      <div className="flex items-center justify-center gap-3 my-3">
        <DeviceStack />
        <span className="text-slate-400">→</span>
        <div className="flex flex-col items-center gap-1">
          <div className="px-4 py-2.5 rounded-lg text-sm font-medium bg-slate-200 text-slate-600 border border-slate-300">
            Hotel WiFi
          </div>
          <span className="text-xs text-slate-400">New password</span>
        </div>
      </div>
      <p className="text-xs text-slate-500 text-center italic mt-2">
        Every new location = new password for every device
      </p>

      <hr className="border-t border-dashed border-slate-300 my-7" />

      <p className="font-semibold text-slate-700 mb-5 text-center text-sm">With Megadish</p>
      <div className="flex items-center justify-center gap-3 my-3 flex-wrap">
        <DeviceStack />
        <span className="text-slate-400">→</span>
        <div className="px-4 py-2.5 rounded-lg text-sm font-medium bg-green-600 text-white">
          Megadish
        </div>
        <span className="text-slate-400">→</span>
        <div className="flex flex-col gap-1">
          {['Hotel', 'Train', 'Phone', 'Café'].map((n) => (
            <div key={n} className="px-3 py-1 rounded-md text-xs font-medium bg-blue-100 text-blue-700 border border-blue-200">
              {n}
            </div>
          ))}
        </div>
      </div>
      <p className="text-xs text-slate-500 text-center italic mt-2">
        Family always connects to "Megadish" — you handle what's underneath
      </p>
    </>
  );

  const explanation = (
    <>
      <h3 className="text-xl font-semibold text-slate-800 mb-4">Why sharing matters</h3>
      <p className="text-slate-600 mb-4 leading-relaxed">
        Every time you arrive somewhere new — a hotel, a train, a café — everyone 
        in the family needs the WiFi password. You end up typing it into four devices, 
        or dictating it across the room, or giving up entirely.
      </p>
      <p className="text-slate-600 leading-relaxed">
        With Megadish, the family only ever connects to one network: "Megadish". 
        It's already saved on their devices. When you arrive somewhere new, 
        <strong> you </strong>connect Megadish to the local WiFi — they don't need 
        to know or care what's underneath.
      </p>
    </>
  );

  return (
    <PillarPageLayout
      icon="👨‍👩‍👧‍👦"
      title="Share"
      subtitle="One network the whole family knows"
      color="blue"
      diagram={diagram}
      explanation={explanation}
      benefits={[
        'Family devices auto-connect — no new passwords to share',
        'Kids don\'t need access to hotel/café passwords',
        'Switch between WiFi sources without telling anyone',
        'Use your phone hotspot and the family won\'t overload it — Megadish manages bandwidth',
        'Works on trains, planes, ships, hotels — anywhere',
      ]}
      scenarios={[
        { emoji: '🚂', label: 'Train journey with family' },
        { emoji: '✈️', label: 'In-flight WiFi sharing' },
        { emoji: '🚢', label: 'Cruise ship WiFi' },
        { emoji: '🏨', label: 'Hotel room with kids' },
      ]}
    />
  );
};

export default SharePage;
